import { debugLogReportBusinessStep } from '@/src/components/Debug/Utils/debugGlobalData';

const Logan = Mach.requireModule('Logan');

const defaultTags = {
  componentId: 'c_home_page_main_logan',
};

const HomePageLoganType = {
  API: 'HomePageAPI',
  Main: 'HomePageMain',
  Header: 'HomePageHeader',
  Feed: 'HomePageFeed',
};

function logan(loganType, logData) {
  if (Logan) {
    try {
      const logStr = JSON.stringify({ ...defaultTags, ...logData, loganType });
      if (logStr) {
        Logan.log(logStr);
      }
    } catch (error) {}
  }

  if (Mach.env.isDebug) {
    try {
      const logStr = JSON.stringify({ ...defaultTags, ...logData, loganType });
      if (logStr) {
        debugLogReportBusinessStep('🐤Logan', '🐤【Logan】reportLogan', logStr);
      }
      // console.log(logStr);
    } catch (error) {
      console.log('Logan ❌❌❌❌❌=====', error);
    }
  }
}

export { logan, HomePageLoganType };
